export enum ProjectsSettings {
    CATEGORII_PROIECTE = 'Categorii Proiecte',
    SECTIUNI_PROIECTE = 'Secțiuni Proiecte',
    // DEPARTAMENTE_PROIECTE = 'Departamente Proiecte',
    STATUSURI_PROIECTE = 'Status Proiecte',
    TAGURI_PROIECTE = 'Taguri Proiecte',
    FURNIZORI_PROIECTE = 'Furnizori Proiecte',
    AGENTI_PROIECTE = 'Agenți Proiecte',
    MOTIVE_DELAY_PROIECTE = 'Motive Delay Proiecte',
    OPERATORI_PROIECTE = 'Operatori Proiecte',
}
